// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__1Fvof","disabled":"FileBtn_disabled__17j9G","warn":"FileBtn_warn__2wsRV","fade":"FileBtn_fade__9hcun"};